import "./style.scss";

export const PoliticaPrivacidade = () => (
  <main className="container p-4 politica-privacidade" style={{ maxWidth: 1000 }}>
    <h1>Política de Privacidade</h1>
    <p>
      A sua privacidade é muito importante para nós. Esta Política de Privacidade descreve como coletamos, usamos e protegemos seus dados pessoais ao se
      cadastrar em nossa comunidade para empreendedores.
    </p>
    <h2>1. Dados coletados</h2>
    <p>Ao preencher o formulário, coletamos as seguintes informações:</p>
    <ul>
      <li>Nome</li>
      <li>Nome da empresa</li>
      <li>E-mail</li>
      <li>Telefone/WhatsApp</li>
    </ul>
    <h3>1.1 Formulários contextualizados</h3>
    <p>
      Para formulários de diagnóstico coletamos informações adicionais, informadas pelo usuário, tais como: redes sociais, canais de aquisição, problemas atuais
      e aspectos da gestão, com intuito de conhecer a empresa e obter contexto para podermos colaborar com a empresa que busca nossos serviços.
    </p>
    <h2>2. Finalidade da coleta</h2>
    <p>Os dados fornecidos serão utilizados exclusivamente para:</p>
    <ul>
      <li>Enviar conteúdos, materiais e informações relacionados à comunidade para empreendedores;</li>
      <li>Manter comunicação sobre novidades, eventos e materiais de apoio.</li>
    </ul>
    <p>Não utilizaremos seus dados para outros fins sem seu consentimento.</p>
    <h2>3. Compartilhamento de dados</h2>
    <p>
      Seus dados <strong>não serão vendidos, compartilhados ou repassados</strong> a terceiros, exceto quando exigido por lei.
    </p>
    <h2>4. Armazenamento e segurança</h2>
    <p>Adotamos medidas de segurança adequadas para proteger suas informações pessoais contra acessos não autorizados, alterações ou divulgação.</p>
    <h2>5. Cancelamento e exclusão</h2>
    <p>
      Você poderá, a qualquer momento, solicitar a interrupção do envio de conteúdos ou a exclusão dos seus dados da nossa base, clicando na opção de
      descadastro presente em nossas comunicações ou entrando em contato conosco.
    </p>
    <h2>6. Alterações desta política</h2>
    <p>
      Podemos atualizar esta Política de Privacidade periodicamente. Recomendamos que você consulte esta página de tempos em tempos para estar ciente de
      eventuais mudanças.
    </p>
    <h2>7. Contato</h2>
    <p>Se tiver dúvidas sobre esta Política de Privacidade ou sobre o uso de seus dados, entre em contato pelo e-mail: [falecom@emprezas.com.br].</p>
  </main>
);
